module.exports = __webpack_public_path__ + "static/media/33-12.67f1f3ae.mp3";